module.exports = __webpack_public_path__ + "static/media/gallery15.18947683.jpg";